<template>
  <div class="wrapper" :style="cssProps">
    <div class="loading">
      <pulse-loader
        :color="'#af7c00'"
        :size="'2em'"
        :loading="loading"
      ></pulse-loader>
    </div>
    <div class="header" v-if="!loading">
      <parkenda-menu class="menu"></parkenda-menu>
    </div>
    <div class="content" v-if="!loading">
      <img :src="parkendaValetImage" class="parkendaValetImage" />
      <p class="welcome">{{ this.$store.getters.TRANSLATIONS["welcome"] }}</p>
      <hr class="line" />
      <p class="text1">
        {{ this.$store.getters.TRANSLATIONS["why_park_when_you_can"] }}
        <br />{{ this.$store.getters.TRANSLATIONS["parkenda"] }}
      </p>
      <p class="text2">
        {{ this.$store.getters.TRANSLATIONS["your_member_id"] }}
      </p>
      <barcode
        v-model="barCode"
        class="barcode"
        :options="{
          displayValue: true
        }"
      ></barcode>
    </div>
    <div class="footer" v-if="!loading">
      <button v-on:click="marketing" class="button add_voucher_button">
        {{ this.$store.getters.TRANSLATIONS["add_voucher"] }}
      </button>
      <button v-on:click="history" class="button view_history_button">
        {{ this.$store.getters.TRANSLATIONS["view_history"] }}
      </button>
    </div>
    <v-dialog style="margin-top: 25%" :width="350" />
    <parkenda-toolbar></parkenda-toolbar>
  </div>
</template>

<script>
export default {
  created: function () {
    if (!this.$storage.get("parkendaToken") || !this.$store.getters.USER) {
      this.$router.push("/login");
    } else {
      const timeout = setTimeout(() => {
        this.loading = true;
      }, 0);
      this.$http
        .get(`${process.env.SERVER_URL}/FA04C1C44AFA43CF9170E1D70335412B`, {
          headers: {
            "x-access-token": this.$storage.get("parkendaToken")
          }
        })
        .then((response) => {
          console.log("Have active parking response");
          console.log(response);
          if (response.data && response.data.haveActiveParking) {
            this.$store.dispatch("SAVE_USER_HAVE_ACTIVE_PARKING", true);
            this.$router.push("/currentParking");
          } else {
            this.$http
              .get(
                `${process.env.SERVER_URL}/2600ED9F52C14E3D929B271668DE977E`,
                {
                  headers: {
                    "x-access-token": this.$storage.get("parkendaToken")
                  }
                }
              )
              .then((response) => {
                console.log("Get current user response:");
                console.log(response);
                if (response.data) {
                  this.$store.dispatch("SAVE_USER", response.data);
                  (this.barCode =
                    this.$store.getters.USER.barcode || "No barcode yet"),
                    (this.token = this.$storage.get("parkendaToken"));
                }
              });
          }
        })
        .finally(() => {
          clearTimeout(timeout);
          this.loading = false;
        });
    }
  },
  data() {
    return {
      cssProps: {
        backgroundImage: `url(${require("@/assets/new_design/AdobeStock_317642059.png")})`,
        "background-position": "center",
        "background-repeat": "no-repeat",
        "background-size": "cover"
      },
      loading: true,
      token: null,
      barCode: this.$store.getters.USER.barcode || "No barcode yet",
      parkendaValetImage: require("@/assets/new_design/Parkenda_Brandmark.png"),
      menu: require("@/assets/menu.png"),
      menuLogo: require("@/assets/logo.png"),
      open: false,
      history: () => {
        this.$router.push("/historyVehicles");
      },
      marketing: () => {
        this.$router.push("/marketCampagnsList");
      }
    };
  }
};
</script>

<style scoped src="../styles/main.css"></style>
<style scoped>
.parkendaValetImage {
  display: block;
  width: 28%;
  border-radius: 30px;
  display: block;
  margin: 3vh auto 0;
}
.view_history_button {
  background-color: white;
  color: #fbae31;
  border: 1px solid #fbae31;
}
.add_voucher_button {
  margin-bottom: auto;
}
.welcome {
  margin-top: 3px;
  color: #fbae31;
  font-size: 6vw;
  font-family: "BrandonGrotesqueBold";
}
.line {
  background: rgba(114, 174, 255, 1);
  border-color: rgba(114, 174, 255, 1);
  margin: 1vh 17vw;
}
.text1 {
  font-family: "BrandonGrotesqueMedium";
  font-size: 4vw;
}
.text2 {
  margin-top: 4vh;
  font-family: "BrandonGrotesqueBold";
  font-size: 5vw;
  color: rgba(114, 174, 255, 1);
}
.barcode {
  width: 60%;
  margin: 5px auto;
  border: 2px solid rgba(114, 174, 255, 1);
  padding: 10px;
  border-radius: 25px;
}
.button {
  margin-top: 3px;
  margin-bottom: 3px;
}
.footer {
  height: 21vh;
  display: flex;
  flex-direction: column;
}
</style>



// WEBPACK FOOTER //
// src/components/ParkendaValet.vue